import SceneObject from "./sceneobject";
import ShaderService from "../shader/shader_service";
import ResourceService from "../resource/resourceservice";
import Camera from "./camera";
import DioramaPanelRenderPipeline from "../render/pipelines/diorama_panel_renderpipeline";
import DioramaCamera from "./diorama_camera";

export default class DioramaPanel extends SceneObject 
{
  shader_name:string;
  texture_name: string;
  width: number;
  height: number;
  diorama_renderpipeline?: DioramaPanelRenderPipeline;

  constructor(key: string, shader_name: string, texture_name: string, width: number, height: number) {
    super(key);
    this.shader_name = shader_name;
    this.texture_name = texture_name;
    this.width = width;
    this.height = height;
  }

  async build(
    device: GPUDevice,
    format: GPUTextureFormat,
    shader_service: ShaderService,
    resource_service: ResourceService
  ): Promise<void> {
   this.diorama_renderpipeline = new DioramaPanelRenderPipeline(this.key,this.shader_name,this.texture_name,this.width,this.height);
    await this.diorama_renderpipeline.build(
      device,
      format,
      shader_service,
      resource_service,
    );

  
    this.transform.update_matrix();
  }

  set_diorama_pose(
    x: number,
    y: number,
    z: number,
    camera: DioramaCamera
  ) {
    this.transform.set_position(x, y, z);
    this.transform.set_rotation(0, camera.get_shared_panel_yaw(), 0);
    this.transform.update_matrix();
  }

  prepare(device: GPUDevice, camera: Camera): void {
    (this.diorama_renderpipeline as DioramaPanelRenderPipeline)?.prepare(device, camera, this.transform);
  }

  draw(pass: GPURenderPassEncoder): void {
    this.diorama_renderpipeline?.draw(pass);
  }
}